<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import chevron from "@core/assets/icons/chevron.svg?raw";
	import Formatted from "./Formatted.svelte";
	import Icon from "./Icon.svelte";

	const {
		title,
		children,
		group,
		class: customClass,
	}: {
		title: string;
		children?: Snippet;
		group?: string;
		class?: ClassValue;
	} = $props();
</script>

<details class={["group/disclosure border-t border-fcrgray-100/12 last-of-type:border-b", customClass]} name={group}>
	<summary
		class="text-sm/tight sm:text-lg/normal marker:hidden list-none [&::-webkit-details-marker]:hidden flex items-center justify-between cursor-pointer py-4"
	>
		<div class="font-medium">
			<Formatted text={title} />
		</div>
		<div
			class="group-open/disclosure:rotate-180 group-open/disclosure:text-fcrbrown text-fcrdarkgray transition-transform"
			aria-hidden="true"
		>
			<Icon icon={chevron} />
		</div>
	</summary>
	<div class="mb-4 text-sm sm:text-base text-fcrgray">
		{@render children?.()}
	</div>
</details>
